import { EBINQUIRY, RESPONSEDATA } from "app/shared/services/services-model.type";
import {
  FETCH_BILLING_INFO_REQUEST,
  FETCH_BILLING_INFO_SUCCESS,
  FETCH_BILLING_INFO_FAILURE,
  FETCH_BILLING_PACKAGE_REQUEST,
  FETCH_BILLING_PACKAGE_SUCCESS,
  FETCH_BILLING_PACKAGE_FAILURE,
  FETCH_BILLING_CREATE_REQUEST,
  FETCH_BILLING_CREATE_SUCCESS,
  FETCH_BILLING_CREATE_FAILURE,
  FETCH_BILLING_CONFIRM_REQUEST,
  FETCH_BILLING_CONFIRM_SUCCESS,
  FETCH_BILLING_CONFIRM_FAILURE,
  FETCH_BILLING_AUTHORIZATION_KEY_REQUEST,
  FETCH_BILLING_AUTHORIZATION_KEY_SUCCESS,
  FETCH_BILLING_AUTHORIZATION_KEY_FAILURE,
  SET_BILLING_STORE,
  SET_BILLING_RESET,
  FETCH_BILLING_CUSTOMER_INFO_REQUEST,
  FETCH_BILLING_CUSTOMER_INFO_SUCCESS,
  FETCH_BILLING_CUSTOMER_INFO_FAILURE,
  FETCH_BILLING_MAKE_FEE_REQUEST,
  FETCH_BILLING_MAKE_FEE_FAILURE,
  FETCH_BILLING_MAKE_FEE_SUCCESS,
} from "./actions.type";
import {
  FetchBillingCreateRequest,
  FetchBillingCreateSuccess,
  FetchBillingCreateFailure,
  FetchBillingConfirmRequest,
  FetchBillingConfirmSuccess,
  FetchBillingConfirmFailure,
  FetchBillingAuthorizationRequest,
  FetchBillingAuthorizationSuccess,
  FetchBillingAuthorizationFailure,
  DataBillingCreate,
  SetBillingStore,
  BillingState,
  SetBillingReset,
  FetchBillingCustomerInfoRequest,
  FetchBillingCustomerInfoSuccess,
  FetchBillingCustomerInfoFailure,
  FetchBillingInfoRequest,
  FetchBillingInfoSuccess,
  FetchBillingInfoFailure,
  FetchBillingMakeFeeRequest,
  FetchBillingMakeFeeFailure,
  FetchBillingMakeFeeSuccess,
  FetchBillingPackageRequest,
  FetchBillingPackageSuccess,
  FetchBillingPackageFailure,
} from "./types";

export const fetchBillingInfoRequest = (payload?: string): FetchBillingInfoRequest => ({
  type: FETCH_BILLING_INFO_REQUEST,
  payload,
});

export const fetchBillingInfoSuccess = (payload?: RESPONSEDATA): FetchBillingInfoSuccess => ({
  type: FETCH_BILLING_INFO_SUCCESS,
  payload,
});

export const fetchBillingInfoFailure = (payload?: string): FetchBillingInfoFailure => ({
  type: FETCH_BILLING_INFO_FAILURE,
  payload,
});

export const fetchBillingPackageRequest = (payload?: DataBillingCreate): FetchBillingPackageRequest => ({
  type: FETCH_BILLING_PACKAGE_REQUEST,
  payload,
});

export const fetchBillingPackageSuccess = (payload?: RESPONSEDATA): FetchBillingPackageSuccess => ({
  type: FETCH_BILLING_PACKAGE_SUCCESS,
  payload,
});

export const fetchBillingPackageFailure = (payload?: string): FetchBillingPackageFailure => ({
  type: FETCH_BILLING_PACKAGE_FAILURE,
  payload,
});

export const fetchBillingCreateRequest = (payload: DataBillingCreate): FetchBillingCreateRequest => ({
  type: FETCH_BILLING_CREATE_REQUEST,
  payload,
});

export const fetchBillingCreateSuccess = (payload?: RESPONSEDATA): FetchBillingCreateSuccess => ({
  type: FETCH_BILLING_CREATE_SUCCESS,
  payload,
});

export const fetchBillingCreateFailure = (payload?: string): FetchBillingCreateFailure => ({
  type: FETCH_BILLING_CREATE_FAILURE,
  payload,
});

export const fetchBillingConfirmRequest = (payload?: RESPONSEDATA): FetchBillingConfirmRequest => ({
  type: FETCH_BILLING_CONFIRM_REQUEST,
  payload,
});

export const fetchBillingConfirmSuccess = (payload?: RESPONSEDATA): FetchBillingConfirmSuccess => ({
  type: FETCH_BILLING_CONFIRM_SUCCESS,
  payload,
});

export const fetchBillingConfirmFailure = (payload?: string): FetchBillingConfirmFailure => ({
  type: FETCH_BILLING_CONFIRM_FAILURE,
  payload,
});

export const fetchBillingAuthorizationRequest = (payload?: RESPONSEDATA, code?: string): FetchBillingAuthorizationRequest => ({
  type: FETCH_BILLING_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchBillingAuthorizationSuccess = (payload?: RESPONSEDATA): FetchBillingAuthorizationSuccess => ({
  type: FETCH_BILLING_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchBillingAuthorizationFailure = (errorOTP: boolean, payload?: string): FetchBillingAuthorizationFailure => ({
  type: FETCH_BILLING_AUTHORIZATION_KEY_FAILURE,
  errorOTP,
  payload,
});

export const setBillingStore = (payload: BillingState): SetBillingStore => ({
  type: SET_BILLING_STORE,
  payload,
});

export const setBillingReset = (): SetBillingReset => ({
  type: SET_BILLING_RESET,
});

// Billing Detail Account
export const fetchBillingCustomerInfoRequest = (payload: DataBillingCreate): FetchBillingCustomerInfoRequest => ({
  type: FETCH_BILLING_CUSTOMER_INFO_REQUEST,
  payload,
});

export const fetchBillingCustomerInfoSuccess = (payload?: EBINQUIRY): FetchBillingCustomerInfoSuccess => ({
  type: FETCH_BILLING_CUSTOMER_INFO_SUCCESS,
  payload,
});

export const fetchBillingCustomerInfoFailure = (payload?: string): FetchBillingCustomerInfoFailure => ({
  type: FETCH_BILLING_CUSTOMER_INFO_FAILURE,
  payload,
});

// Tính phí
export const fetchBillingMakeFeeRequest = (payload: DataBillingCreate): FetchBillingMakeFeeRequest => ({
  type: FETCH_BILLING_MAKE_FEE_REQUEST,
  payload,
});

export const fetchBillingMakeFeeFailure = (payload?: string): FetchBillingMakeFeeFailure => ({
  type: FETCH_BILLING_MAKE_FEE_FAILURE,
  payload,
});

export const fetchBillingMakeFeeSuccess = (payload?: RESPONSEDATA): FetchBillingMakeFeeSuccess => ({
  type: FETCH_BILLING_MAKE_FEE_SUCCESS,
  payload,
});
